import React from 'react';

function Mapa(){
    return(
        <div>
            <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3654.768851398997!2d-46.72409872592733!3d-23.648447678740023!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x94ce510ee139c783%3A0xeb2c662d96597994!2sR.%20Bento%20Branco%20de%20Andrade%20Filho%2C%20379%20-%20Jardim%20Dom%20Bosco%2C%20S%C3%A3o%20Paulo%20-%20SP%2C%2004757-000!5e0!3m2!1spt-BR!2sbr!4v1711547258139!5m2!1spt-BR!2sbr" title="Mapa de localização da clínica" width='50%' height='450'></iframe>
        </div>
    );
}

export default Mapa